import { loadStorms } from '../../api/alerts/storms.api';

const state = {
  storms: []
};

const mutations = {
  setStorms(state, data){
    state.storms = data ? data :  [];
  },
  cleanStorms(state){
    state.storms = [];
  },
};

const actions = {
  async loadStormAlerts( {commit}, payload){
    const {limit} = payload; 
    
    try{
      const response = await loadStorms(limit);
      commit('setStorms', response.data);
    }catch(error){
      commit('setStorms', undefined);
    }
  },
};

const getters = {
  storms: (state) => state.storms
};

export default {
    state,
    mutations,
    actions,
    getters
}
